import React from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import Footer from "../layout/footer";
import CompanyHeader from "../layout/company_header";
import { Tooltip } from "react-tooltip";
import HorizontalMenu from "./HorizontalMenu";
const isAdminAuthenticated = () => {
  const isAuth = localStorage.getItem("company");
  
  if (isAuth) {
    return true;
  }
  return false;
};

const CompanyProtectedRoutes = () => {
  // Check if admin is authenticated
  const isAuthenticated = isAdminAuthenticated();

  const location = useLocation();
  const isPOSRoute = location.pathname === "/pos";
  const path = location.pathname;

  const groups = {
    
    management: [
      { path: "/roles", label: "Roles Management", icon: "ti ti-id" },
      { path: "/permissions", label: "Task Permissions", icon: "ti ti-lock" },
      { path: "/branch", label: "Branch Management", icon: "ti ti-building-bank" },
      { path: "/branch/users", label: "User Management", icon: "ti ti-users" },
    ],
    setup: [
      { path: "/suppliers", label: "Suppliers", icon: "ti ti-truck-delivery" },
      { path: "/customers", label: "Customers", icon: "ti ti-user-dollar" },
      { path: "/setup/taxes", label: "Taxes", icon: "ti ti-percentage" },
      { path: "/setup/units", label: "Units", icon: "ti ti-ruler-measure" },
      { path: "/brands", label: "Brands", icon: "ti ti-tag" },
      { path: "/product-attributes", label: "Attributes", icon: "ti ti-list-details" },
    ],
    import: [
      { path: "/import", label: "Import Products", icon: "ti ti-upload" },
      { path: "/import/images", label: "Import Product Images", icon: "ti ti-photo" },
    ],
    purchases: [
      { path: "/setup/categories", label: "Categories", icon: "ti ti-category" },
      { path: "/raw-products", label: "Purchased Products", icon: "ti ti-box" },
    ],
    final_products: [
      { path: "/categories", label: "Categories", icon: "ti ti-category-2" },
      { path: "/products", label: "Products", icon: "ti ti-package" },
    ],
    purchase_system: [
      { path: "/payment/supplier", label: "Vendor Payments", icon: "ti ti-credit-card" },
      { path: "/pushed-purchase", label: "Purchase Request", icon: "ti ti-file-plus" },
      { path: "/approved-purchase", label: "Approved Purchases", icon: "ti ti-badge-check" },
      { path: "/raw-products/stock", label: "Allocate Items", icon: "ti ti-transfer" },
      { path: "/raw-products/purchases", label: "Purchase Entry", icon: "ti ti-file-invoice" },
      { path: "/raw-products-stock", label: "Product Stock", icon: "ti ti-archive" },
    ],
    sales_system: [
      { path: "/reports/sales", label: "Sales Report", icon: "ti ti-chart-bar" },
      { path: "/reports/stock", label: "Stock Report", icon: "ti ti-chart-line" },
      { path: "/tenders/sale", label: "Sales Request", icon: "ti ti-file-search" },
      { path: "/tenders/cost", label: "Cost Estimation", icon: "ti ti-calculator" },
      { path: "/tenders/order", label: "Orders", icon: "ti ti-shopping-cart" },
      { path: "/tenders/delivered", label: "Delivery", icon: "ti ti-truck" },
      { path: "/tenders/production", label: "Production Orders", icon: "ti ti-building-factory" },
    ],
    accounts: [
      { path: "/accounts/sales-bills", label: "Sales Bills", icon: "ti ti-receipt" },
      { path: "/accounts/bills", label: "Bill Management", icon: "ti ti-file-invoice" },
      { path: "/accounts/credit-notes", label: "Credit Notes", icon: "ti ti-notes" },
      { path: "/accounts/assets", label: "Assets Management", icon: "ti ti-briefcase" },
    ],
    tasks: [
      { path: "/task/assigned-to-you", label: "For You", icon: "ti ti-user-check" },
      { path: "/task/assigned-by-you", label: "By You", icon: "ti ti-user-share" },
    ],
  };

  // Determine which group to show
  const activeGroup = Object.entries(groups).find(([_, items]) =>
    items.some((item) => path.startsWith(item.path))
  );

  const activeMenus = activeGroup ? activeGroup[1] : [];

  return isAuthenticated ? (
    <div className="main-wrapper">
      <CompanyHeader />
      <div className={`main-content page-wrapper ${isPOSRoute?"m-0":""} ${!activeGroup ? "no-menu-padding" : ""}`}>
        <HorizontalMenu/>
        <div className={`content page-content ${isPOSRoute?"p-0":""}`}>
          <div className="container-fluid">
            <Outlet />
          </div>
        </div>
      </div>
      {!isPOSRoute && <Footer />}
      <Tooltip id="tooltip" place="top" />
    </div>

  ) : <Navigate to="/login" />;
};

export default CompanyProtectedRoutes;
